import React from 'react'
import '../styles/Wrapper.css'
import DefaultWrapper from './DefaultWrapper'
import ManageVisitWrapper from './ManageVisitWrapper'

function SideFilters({ children, badges, extraFilters, isManageVisit, setShow, show }) {
  return (
      isManageVisit
        ? <ManageVisitWrapper
            extraFilters={extraFilters}
            badges={badges}
            setShow={setShow}
            show={show}
          >{children}</ManageVisitWrapper>
        : <DefaultWrapper extraFilters={extraFilters} badges={badges}>{children}</DefaultWrapper>
  )
}

export default SideFilters
